/**
 * Mounting the suggestion popups.
 *
 * `@tiptap/react` 2.27 renders a suggestion popup into a **detached**
 * element and leaves attaching it to the document to the caller. The
 * extension used to do that itself on an older release; after the bump the
 * "/" , "[[" and "@" menus were rendered into a node that was never in the
 * document, so they never became visible.
 *
 * The popups position themselves with `position: fixed` (see
 * `useSuggestionPosition`), so the wrapper only has to sit in the document
 * without taking part in the layout.
 */

import { ReactRenderer } from '@tiptap/react'

/** Attaches a suggestion popup to the document. */
export function mountSuggestion(component: ReactRenderer): void {
  const element = component.element as HTMLElement
  if (element.parentNode) return
  element.style.position = 'fixed'
  element.style.top = '0'
  element.style.left = '0'
  element.style.zIndex = '60'
  document.body.appendChild(element)
}

/** Detaches a suggestion popup and releases its renderer. */
export function unmountSuggestion(component: ReactRenderer | null): void {
  if (!component) return
  component.destroy()
  const element = component.element as HTMLElement
  element.remove()
}
